module.exports = __webpack_public_path__ + "static/media/sales-order-slide-9.7081a56d.jpg";